"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceWithdrawsListCtl = /** @class */ (function (_super) {
    __extends(FinanceWithdrawsListCtl, _super);
    function FinanceWithdrawsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_id; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_player_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_email; });
        _this.dk_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_id; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_partner_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_email; });
        _this.dk_withdraw_basis_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_basis_title; });
        _this.dk_withdraw_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_currency_title; });
        _this.dk_amount_in_withdraw_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_withdraw_currency_without_comission; });
        _this.dk_amount_in_withdraw_currency_wit_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_withdraw_currency_with_comission; });
        _this.dk_player_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_title; });
        _this.dk_amount_in_player_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_without_comission; });
        _this.dk_amount_in_player_currency_with_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_with_comission; });
        _this.dk_exchange_rate_withdraw_to_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.exchange_rate_withdraw_to_player; });
        _this.dk_player_withdraw_nocomission_limit_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_withdraw_nocomission_limit_before; });
        _this.dk_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_before; });
        _this.dk_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_after; });
        _this.dk_withdraw_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_code; });
        _this.dk_withdraw_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_title; });
        _this.dk_withdraw_state_complete = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_complete; });
        _this.dk_withdraw_state_error = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_error; });
        _this.dk_withdraw_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_type_code; });
        _this.dk_withdraw_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_type_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_withdraw_data = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_data; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_withdraw_req = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_req; });
        _this.dk_withdraw_resp = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_resp; });
        _this.dk_outer_transaction_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.outer_transaction_id; });
        _this.dk_on_reject_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_reject_player_balance_before; });
        _this.dk_on_reject_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_reject_player_balance_after; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceWithdrawsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
            withdraw_status_filter: [],
            withdraw_type_filter: []
        };
    };
    FinanceWithdrawsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceWithdrawsListCtl.prototype.LoadRangeDataByBrandsList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListWithdrawsByBrandIdAndDateRangeGet.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            all_flowtypes: data.allMoneyflowTypes,
            flow_types_list: data.moneyflow_types,
            login_part: data.login_part,
            is_filter_login_part: data.is_filter_login_part,
            email_part: data.email_part,
            is_filter_email_part: data.is_filter_email_part,
            transaction_part: data.transaction_part,
            is_filter_transaction_part: data.is_filter_transaction_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.withdraw_status_filter = [];
            var withdraw_status_filter_map = new Map();
            //
            _this.DATA.withdraw_type_filter = [];
            var withdraw_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!withdraw_status_filter_map.get(resp.list[i].withdraw_state_title)) {
                    _this.DATA.withdraw_status_filter.push({ text: resp.list[i].withdraw_state_title, value: resp.list[i].withdraw_state_title });
                    withdraw_status_filter_map.set(resp.list[i].withdraw_state_title, resp.list[i].withdraw_state_title);
                }
                if (!withdraw_type_filter_map.get(resp.list[i].withdraw_type_title)) {
                    _this.DATA.withdraw_type_filter.push({ text: resp.list[i].withdraw_type_title, value: resp.list[i].withdraw_type_title });
                    withdraw_type_filter_map.set(resp.list[i].withdraw_type_title, resp.list[i].withdraw_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    withdraw_currency_title: resp.list[i].withdraw_currency_title,
                    amount_in_withdraw_currency_without_comission: resp.list[i].amount_in_withdraw_currency_without_comission,
                    amount_in_withdraw_currency_with_comission: resp.list[i].amount_in_withdraw_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    exchange_rate_withdraw_to_player: resp.list[i].exchange_rate_flow_to_player,
                    player_withdraw_nocomission_limit_before: resp.list[i].player_withdraw_nocomission_limit_before,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    withdraw_basis_title: resp.list[i].withdraw_basis_title,
                    withdraw_type_code: resp.list[i].withdraw_type_code,
                    withdraw_type_title: resp.list[i].withdraw_type_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    partner_id: resp.list[i].partner_id,
                    partner_login: resp.list[i].partner_login,
                    partner_email: resp.list[i].partner_email,
                    withdraw_state_code: resp.list[i].withdraw_state_code,
                    withdraw_state_title: resp.list[i].withdraw_state_title,
                    withdraw_state_complete: resp.list[i].withdraw_state_complete,
                    withdraw_state_error: resp.list[i].withdraw_state_error,
                    withdraw_data: resp.list[i].withdraw_data,
                    withdraw_req: resp.list[i].withdraw_req,
                    withdraw_resp: resp.list[i].withdraw_resp,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    on_reject_player_balance_before: resp.list[i].on_reject_player_balance_before,
                    on_reject_player_balance_after: resp.list[i].on_reject_player_balance_after
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceWithdrawsListCtl.prototype.LoadRangeDataByPlayerId = function (data, onDone) {
        var _this = this;
        webAApi_1.ListWithdrawsByPlayerIdAndDateRangeGet.exec({
            usr_player_id: data.playerId,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.withdraw_status_filter = [];
            var withdraw_status_filter_map = new Map();
            //
            _this.DATA.withdraw_type_filter = [];
            var withdraw_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!withdraw_status_filter_map.get(resp.list[i].withdraw_state_title)) {
                    _this.DATA.withdraw_status_filter.push({ text: resp.list[i].withdraw_state_title, value: resp.list[i].withdraw_state_title });
                    withdraw_status_filter_map.set(resp.list[i].withdraw_state_title, resp.list[i].withdraw_state_title);
                }
                if (!withdraw_type_filter_map.get(resp.list[i].withdraw_type_title)) {
                    _this.DATA.withdraw_type_filter.push({ text: resp.list[i].withdraw_type_title, value: resp.list[i].withdraw_type_title });
                    withdraw_type_filter_map.set(resp.list[i].withdraw_type_title, resp.list[i].withdraw_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    withdraw_currency_title: resp.list[i].withdraw_currency_title,
                    amount_in_withdraw_currency_without_comission: resp.list[i].amount_in_withdraw_currency_without_comission,
                    amount_in_withdraw_currency_with_comission: resp.list[i].amount_in_withdraw_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    exchange_rate_withdraw_to_player: resp.list[i].exchange_rate_withdraw_to_player,
                    player_withdraw_nocomission_limit_before: resp.list[i].player_withdraw_nocomission_limit_before,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    withdraw_basis_title: resp.list[i].withdraw_basis_title,
                    withdraw_type_code: resp.list[i].withdraw_type_code,
                    withdraw_type_title: resp.list[i].withdraw_type_title,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    player_id: 0,
                    partner_id: 0,
                    partner_login: "",
                    partner_email: "",
                    withdraw_state_code: resp.list[i].withdraw_state_code,
                    withdraw_state_title: resp.list[i].withdraw_state_title,
                    withdraw_state_complete: resp.list[i].withdraw_state_complete,
                    withdraw_state_error: resp.list[i].withdraw_state_error,
                    withdraw_data: resp.list[i].withdraw_data,
                    withdraw_req: resp.list[i].withdraw_req,
                    withdraw_resp: resp.list[i].withdraw_resp,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    on_reject_player_balance_before: resp.list[i].on_reject_player_balance_before,
                    on_reject_player_balance_after: resp.list[i].on_reject_player_balance_after
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceWithdrawsListCtl.prototype.DoMarkWithdrawalConfirmed = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoNewWithdrawMarkCommited.exec({ data: { usr_player_moneyflow_id: key } }, function (resp) {
                _tmp.withdraw_state_code = resp.flow_state_code;
                _tmp.withdraw_state_title = resp.flow_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceWithdrawsListCtl.prototype.DoMarkWithdrawalRejected = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoNewWithdrawMarkRejected.exec({ data: { usr_player_moneyflow_id: key } }, function (resp) {
                _tmp.withdraw_state_code = resp.flow_state_code;
                _tmp.withdraw_state_title = resp.flow_state_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return FinanceWithdrawsListCtl;
}(BaseController_1.BaseController));
exports.FinanceWithdrawsListCtl = FinanceWithdrawsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraws_list/ctl/FinanceWithdrawsListCtl.ts
// module id = 875
// module chunks = 0